import SecurityBadgeIconFilled from './SecurityBadgeIconFilled';
export default SecurityBadgeIconFilled;
